import React from "react";
import { Grid } from "semantic-ui-react";
import DropDown from "../../../commonComponents/formComponents/dropDown";
import { useSelector } from "react-redux";
import { TranslateContext } from "../TranslateContext";

import { AddDropdown } from "../../../commonComponents/dropdown/AddDropdown";
import DeleteIcon from "../../../commonComponents/deleteIcon";

const  CustomOfficesDetails=({item:{id,office,type,hideDeleteBtn=false,...rest},deleteData,customOfficeTypeList,onOfficeNameChange,onOfficeTypeChange})=>{
  
  const GuaranteeOfficeList = useSelector((state) => state.DropDownValues.partiesGuaranteeOffices);
  const isExt=type=="EXT"
  const filteredCustomOfficeList=React.useMemo(()=>{
    if(isExt) return [] // in case of EXT we are showing searchBox
    return GuaranteeOfficeList.filter(c=>c.type?.split(',').includes(type))
  },[type,isExt,GuaranteeOfficeList])
 
  const errors=useSelector((state)=>state.ValidationErrors.header?.[`header.customsOffice.${type}`]?.msg)
  const translate = React.useContext(TranslateContext).translate

  return (
    <Grid.Row>
      <Grid.Column
        width="7"
        className="divFormFeild border-bottom b-rw-0"
      >
        <DropDown
          id={`officeType-${id}`}
          label="type"
          className="field-bg dropdown100"
          labelClass="text-none"
          isLabel={true}
          data={customOfficeTypeList}
          value={type || ''}
          onChange={(value) =>onOfficeTypeChange({id,value})}
          {...rest}
        />
        
        
      </Grid.Column>
      <Grid.Column
        width="7"
        className="divFormFeild  border-bottom"
      >
      {
       isExt ? 
       <AddDropdown
                errors={errors}
                boxNumber="44"
                id={`officeName-${id}`}
                type='exitOffice'
                label={translate("OFFICE_NAME", {ns:["default", "header"]})}
                onSelect={({ value }) =>onOfficeNameChange({id,value,type})}
                onBlur={({ value }) => {
                  if(!value?.trim()){
                    onOfficeNameChange({id,value:" ",type})
                  }

                  }}
                selectedValue={office}
                />
:
<DropDown
          id={`officeName-${id}`}
          label={translate("OFFICE_NAME", {ns:["default", "header"]})}
          boxNumber="44"
          clearable
          errors={errors}
          className="field-bg dropdown100"
          labelClass="text-none"
          isLabel={true}
          data={filteredCustomOfficeList}
          value={office}
          displayType={false}
          onChange={(value) =>onOfficeNameChange({id,value,type})}
        />
                
}

      </Grid.Column>

      <Grid.Column width="1" className="icon-delete-add-info">
             { !hideDeleteBtn && <DeleteIcon
              id={`custom-office-delete-${id}`}
                name="trash alternate outline"
                onClick={() =>deleteData({id,type,office:" "})}
              />
             }
      </Grid.Column>
    </Grid.Row>
  );
}
export default React.memo(CustomOfficesDetails)
